import { UNAUTHORIZED_USER_AUTHENTICATED } from './types'

const unauthorizedUserAuthenticated = code => ({
  type: UNAUTHORIZED_USER_AUTHENTICATED,
  payload: code
})

export { unauthorizedUserAuthenticated }
